export interface StoreProps {
    _auth: {
        user: any;
        token: string;
        isLoggedIn: boolean;
    };
    _data: {
        debts: Debt[];
        categories: Category[];
        transactions: Transaction[];
        stats_filter: StatsFilter;
    };
}

export enum HttpStatus {
    BadRequest = 400,
    Unauthorized = 401,
    Forbidden = 403,
    NotFound = 404,
    Success = 200,
    Created = 201,
    InternalServerError = 500,
}

export interface AxiusResponse {
    data: any;
    token: string;
    status: HttpStatus;
    message: string;
    pay: any;
}

export interface Transaction {
    amount: number;
    category: string;
    crdate: string;
    date: string;
    id: number;
    notes: string;
    type: string;
    currency: string;
}

export interface Category {
    name: string;
    crdate: string;
    icon: string;
    id: number;
    budget: number;
    type: 'expense' | 'saving';
}

export interface StatsFilter {
    type: string;
    year: number;
    month: string;
}

export interface Debt {
    amount: number;
    date: string;
    id: number;
    notes: string;
    person: string;
    status: number;
    type: string;
}

export const Currencies = ['AED', 'GHS'];